import { ILmpBlock } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { isValidLmpHeroSubscription } from "./typeguards";
import {  LmpHero, UpdateLmpHeroInputSchema } from "appsync";
import { LmpHeroSubscription } from "../types";


export interface IMatchHero {
  readonly match: LmpHero;
  readonly hasVideo?: boolean;
  readonly isSlim?: boolean;
  readonly hasFollowMatch?: boolean | null;
}

type ITransformedMatch = ILmpBlock['match'] & {
  customCompetitionName?: string;
};

const transformer = (obj: LmpHeroSubscription): ILmpBlock => {

  if (isValidLmpHeroSubscription(obj)) {
    UpdateLmpHeroInputSchema().parse(obj.data?.onUpdateLmpHeroByMatchId);
    const { competition, hasFollowMatch, createdAt, updatedAt, status, ...match } = obj.data.onUpdateLmpHeroByMatchId;  
    
    type ILmpBlockPartial = Omit<ILmpBlock, 'matchId'>;

    const payload: ILmpBlockPartial = {
      match: {
        status: status as ITransformedMatch['status'],
        away: {
          ...match.away,
        } as ITransformedMatch['away'],
        home: {
          ...match.home,
        } as ITransformedMatch['home'],
      },
    };

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in LmpHeroSubscription object",
      data: obj,
    });
  }
};

export default transformer;
